<!-- PaymentIcon.vue -->
<template>
    <svg :class="iconClass" width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.0769 8.46149V4.23071C17.0769 2.8288 15.9404 1.69224 14.5385 1.69224C13.1366 1.69224 12 2.8288 12 4.23071V5.27021C12 7.15917 10.7478 8.81933 8.9315 9.33819L6.0769 10.1538V19.0384C7.12343 20.8699 9.07094 22 11.1802 22H19.6154C21.4847 22 23 20.4847 23 18.6154V11.8461C23 9.97678 21.4847 8.46149 19.6154 8.46149H17.0769Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 22H6.07694V8.46149H1V22Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
